import { useQuery, UseQueryResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { getPublishedProcedureList } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchPublishedProcedures({
  accountId,
}: TVariables): Promise<TResult> {
  const response = await fetch(getPublishedProcedureList(accountId), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data:
    | [
        {
          Id: number;
          Name: string;
        },
      ]
    | undefined;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  accountId: number;
};

function useGetPublishedProcedures(
  accountId: number,
): UseQueryResult<TResult, TError> {
  return useQuery(
    ['get_published_procedures', accountId],
    async () => {
      if (accountId) {
        return await fetchPublishedProcedures({
          accountId,
        });
      }
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetPublishedProcedures };
